<template>
    <div>
        box
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>